import { AfterViewInit, Component, Inject, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';
import { filter } from 'rxjs';
import { verifyLanguage } from '../../shared/constants/app-enums';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
})
export class LanguageComponent implements AfterViewInit {
  lang!: string;
  notificationUrl = environment.sseUrl;
  isProduction = environment.production;
  isLoaded: boolean = false;
  notificationFadeOutTime = environment.notificationTimeout;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private translate: TranslateService,
  ) {
    this.translate.setDefaultLang('en');
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((navEnd: NavigationEnd) => {
      // console.log('NavigationEnd', navEnd);
      let lang = navEnd.urlAfterRedirects.split('/')[1];
      // console.log('NavigationEnd filtered lang level-1 =', lang);
      lang = lang.split('#')[0];
      // console.log('NavigationEnd filtered lang level-2 =', lang);
      lang = lang.split('?')[0];
      // console.log('NavigationEnd filtered lang level-3 =', lang);

      if (lang && verifyLanguage(lang)) {
        this.lang = lang;
      } else {
        this.lang = "en"
      }
      // console.log('current language is =',this.lang)
      this.translate.use(this.lang);
    });
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isLoaded = true;
    }
  }

}
